import { Box, Image, Text } from "@chakra-ui/react";
import { ReactComponent as PlayButton } from '../../svg/play-button.svg'

export default function IndividualVideoCard({ name, id, date, image }) {
    return (
        <Box
            d='flex'
            width='100%'
            justifyContent='flex-start'
            alignItems = 'center'
            py='1rem'
            borderBottom='1px solid rgba(0, 0, 0, 0.05)'
        >
            <Box
                position='relative'
                width='70px'
                height='50px'
            >
                <Image
                    src={image}
                    alt={name}
                    width='70px'
                    height='50px'
                    objectFit='cover'
                    fallbackSrc='https://source.unsplash.com/random/800x600'
                />
                <Box
                    position='absolute'
                    width='100%'
                    height='100%'
                    d='flex'
                    justifyContent='center'
                    alignItems='center'
                    top='0'
                    left='0'
                >
                    <PlayButton fill='white' width='15px' height='15px' />
                </Box>
            </Box>

            <Box
                d='flex'
                flexDir='column'
                w='100%'
                ml='1rem'
            >
                <Text
                    fontSize='14px'
                    color='#333333'
                    fontWeight='700'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                >
                    {name}
                </Text>
                <Text
                    fontSize='12px'
                    color='#00000080'
                    fontWeight='400'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                >
                    {date}
                </Text>

            </Box>
        </Box>
    )
}